import React, { useMemo, useRef } from 'react';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { Pie } from 'react-chartjs-2';
ChartJS.register(ArcElement, Tooltip, Legend);

const SummaryActivityType = ({ summary }) => {
    const chartRef = useRef(null);

    const { types, typeValues } = useMemo(() => {
        let typeValues = [0, 0, 0, 0, 0, 0, 0, 0];
        let types = { 'sum': 0, 'quiz': 0, 'report': 0, 'picture': 0, 'photo': 0, 'youtube': 0, 'meeting': 0, 'userbook': 0, 'dongwha': 0 };
        summary.types.map((item, key) => {
            if (item.name === null) return null;
            types['sum'] += item.value;
            types[item.name] = item.value;
            return null;
        });
        typeValues[0] += types.quiz;
        typeValues[1] += types.report;
        typeValues[2] += types.picture;
        typeValues[3] += types.photo;
        typeValues[4] += types.youtube;
        typeValues[5] += types.meeting;
        typeValues[6] += types.userbook;
        typeValues[7] += types.dongwha;
        return { types, typeValues };
    }, [summary]);

    function getData() {
        const typeChartData = {
            labels: ['퀴즈', '감상문', '독서화', '독서사진', '독서영상', '책이랑나랑', '나도작가다', '동화서당'],
            datasets: [{
                data: typeValues,
                backgroundColor: ['#0b86ab', '#37a64b', '#db3450', '#FFBF00', '#D8FF24', '#9b64ed', '#db7093', '#bc8f8f'],
                hoverBackgroundColor: ['#0b86ab', '#37a64b', '#db3450', '#FFBF00', '#D8FF24', '#9b64ed', '#ff6347', '#800000']
            }]
        };
        return typeChartData;
    }


    return (
        <div className="col12 box activity_status">
            <h3><span className="icon02">독서활동현황</span></h3>
            <div className="row">
                <div className="col2 v_align alignR"><img src={`${process.env.PUBLIC_URL}/images/common/rabbit_icon05.png`} alt="독서활동현황 아이콘" /></div>
                <div className="col4">
                    <ul>
                        <li><p className="category">활동수</p><p className="data">{types.sum}</p></li>
                        <li><p className="category">독서퀴즈</p><p className="data">{types.quiz}<span className="apple">{summary.apple.quiz_count}</span></p></li>
                        <li><p className="category">독서감상문</p><p className="data">{types.report}<span className="apple">{summary.apple.report_count}</span></p></li>
                        <li><p className="category">독서화</p><p className="data">{types.picture}<span className="apple">{summary.apple.picture_count}</span></p></li>
                        <li><p className="category">독서사진</p><p className="data">{types.photo}<span className="apple">{summary.apple.photo_count}</span></p></li>
                        <li><p className="category">독서영상</p><p className="data">{types.youtube}<span className="apple">{summary.apple.youtube_count}</span></p></li>
                        <li><p className="category">책이랑나랑</p><p className="data">{types.meeting}<span className="apple">{summary.apple.meeting_count}</span></p></li>
                        <li><p className="category">나도작가다</p><p className="data">{types.userbook}<span className="apple">{summary.apple.userbook_count}</span></p></li>
                        <li><p className="category">동화서당</p><p className="data">{types.dongwha}<span className="apple">{summary.apple.dongwhaCount}</span></p></li>
                    </ul>
                </div>
                <div className="col4 v_align chart_wrap">
                    <div className="chart">
                        <Pie ref={chartRef}
                            width={300} height={130}
                            data={getData()}
                            options={{
                                responsive: true,
                                maintainAspectRatio: true
                            }}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}
export default SummaryActivityType;